import { BehaviorSubject } from 'rxjs';
import {User} from '../../app/utilities/user';
export class Settings
{
    public static User: BehaviorSubject<User> = new BehaviorSubject(new User());
}